import React from 'react';
import { BaseEdge, EdgeProps, getBezierPath, EdgeLabelRenderer, MarkerType } from '@xyflow/react';

const DefaultEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={MarkerType.Arrow}
        style={{
          ...style,
          strokeWidth: 2,
          stroke: 'var(--edge-stroke)',
        }}
      />
      {data?.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              fontSize: 12,
              pointerEvents: 'all',
            }}
            className="nodrag nopan bg-white px-2 py-1 rounded shadow-md"
          >
            {typeof data.label === 'string' ? data.label : String(data.label)}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default DefaultEdge; 